import API from "serviceshift-ui/api-client";
import EquipmentType from "@/EquipmentTypes/EquipmentType.js";
import sortBy from "lodash/sortBy";

export function sortEquipmentTypes(equipmentTypes = []) {
    return sortBy(equipmentTypes, item => item.name.toLowerCase());
}

export default {
    async archiveEquipmentType(_, link) {
        return API.makeRequest(link, { method: "PUT" });
    },
    async createEquipmentType(_, data) {
        return API.makeRequest("/v2/equipment_types", { method: "POST", data });
    },
    async fetchEquipmentTypes({ commit }) {
        try {
            const response = await API.makeRequest("/v2/equipment_types", {
                method: "GET",
            });
            commit("replace", {
                state: "equipmentTypes",
                data: sortEquipmentTypes(
                  response.data.map(resultItem => EquipmentType.fromAPI(resultItem))
                )
            });
        } catch (e) {
            //no-op
        }
    },
    unarchiveEquipmentType(_, link) {
        return API.makeRequest(link, { method: "PUT" });
    },
    updateEquipmentType(_, { link, data }) {
        return API.makeRequest(link, { method: "PUT", data });
    },
};
